import { useState, useEffect } from 'react';
import useWindowSizeDebounced from './../../../../../hooks/useWindowSizeDebounced';

const useSidebarOpen = () => {
  const [isOpen, setIsOpen] = useState(true);
  const { width } = useWindowSizeDebounced();

  const toggleSidebar = () => setIsOpen(!isOpen);

  const isSmallScreen = width < 1368;

  useEffect(() => {
    if (isSmallScreen) {
      return setIsOpen(false);
    } else {
      return setIsOpen(true);
    }
  }, [isSmallScreen, setIsOpen]);

  return { isOpen, toggleSidebar };
};

export default useSidebarOpen;
